import { useParams } from 'react-router-dom'
import PlopReport from 'components/utilized/plop/PlopReport'
import PageBody from 'components/atoms/PageBody'

const PlopReportRecordCrudPage = () => {
  const params = useParams()
  const id = params?.id

  return (
    <>
      {id && <PageBody><PlopReport id={id} /></PageBody> }
    </>
  )
}
export default PlopReportRecordCrudPage
